import { useEffect, useState } from 'react';

/** Wall-clock `now`, re-read every `intervalMs` so countdowns stay current. */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}

/** "3h 12m" / "45m" / "less than a minute" until `expiresAt`. */
export function formatRemaining(expiresAt: string, now: number): string {
  const mins = Math.floor((Date.parse(expiresAt) - now) / 60_000);
  if (mins < 1) return 'less than a minute';
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h === 0) return `${m}m`;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

/** "6:40 PM" today, "Thu 6:40 PM" on another day — in the viewer's time zone. */
export function formatExpiryClock(expiresAt: string, now: number): string {
  const at = new Date(expiresAt);
  const sameDay = at.toDateString() === new Date(now).toDateString();
  return at.toLocaleString(undefined, {
    ...(sameDay ? {} : { weekday: 'short' }),
    hour: 'numeric',
    minute: '2-digit',
  });
}
